import React, { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import { setGuidId, setRemark, setCycleDate, setSystemSourcePDF } from '../../PersonalAreaInvoicesSlice';
import { getInvoiceDataAsync } from '../../PersonalAreaInvoicesAsyncThunk';
import SwiperCore from 'swiper';
import { Navigation , Scrollbar} from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/swiper-bundle.css';

SwiperCore.use([Navigation, Scrollbar]);

function Graph(props) {
  const { invoicesInfo, history } = props;
  const monthView = history?.filter(item => item.isViewPdf !== true).reverse()
  const swiperRef = useRef(null);

    useEffect(() => {
    if (history?.length > 0 && swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.update();
    }
  }, [history]); // or any dependency that affects the slides


  const clickColumnGraph = (i, monthDetails) => {
    if(monthDetails.guidId && i < 6){
      const invoicesDisplay = props.invoicesInfo?.filter(item => item.isViewPdf !== true).reverse();
      const selectedInvoiceMonth = invoicesDisplay.find(item => item.guidId === monthDetails.guidId);
      if (selectedInvoiceMonth && selectedInvoiceMonth.guidId && selectedInvoiceMonth.guidId !== "") {
        props.setGuidId(monthDetails.guidId);
        props.setCycleDate(monthDetails.cycleDate);
        props.setSystemSourcePDF(selectedInvoiceMonth.systemSourcePDF);
        props.setRemark(null);
        getData();
      } else {
        props.setCycleDate(monthDetails.cycleDate);
        props.setRemark(<p className='remark-month'>אין לך חשבוניות לחודש {monthDetails.cycleMonthName}</p>);
      }
    }
  };

  function getData() {
    props.getInvoiceDataAsync();
  };

  const shortMonths = (item, i) => {
    let shortMonth = '';
    const cycleYear = item.cycleYear.substring(2);
    const periodYear = item.periodYear.substring(2);
    const year = props.isEnergy ? periodYear : cycleYear;
    const cycleMonthName = props.isEnergy ? item.periodMonthName : item.cycleMonthName;
    switch (cycleMonthName?.trim()) {
      case 'ינואר':
        shortMonth = 'ינו';
        break;
      case 'פברואר':
        shortMonth = 'פבר';
        break;
      case 'מרץ':
        shortMonth = 'מרץ';
        break;
      case 'אפריל':
        shortMonth = 'אפר';
        break;
      case 'מאי':
        shortMonth = 'מאי';
        break;
      case 'יוני':
        shortMonth = 'יוני';
        break;
      case 'יולי':
        shortMonth = 'יולי';
        break;
      case 'אוגוסט':
        shortMonth = 'אוג';
        break;
      case 'ספטמבר':
        shortMonth = 'ספט';
        break;
      case 'אוקטובר':
        shortMonth = 'אוק';
        break;
      case 'נובמבר':
        shortMonth = 'נוב';
        break;
      case 'דצמבר':
        shortMonth = 'דצמ';
        break;
      default:
        shortMonth = item.cycleMonthName;
    };
    return (
      <button key={i} className='container-info-graph' onClick={() => clickColumnGraph(i,item)}>
        <div className='wrapper-graph-height'>
        <div className='price'>
          {item?.amountData?.amount && (
            <>
              ₪{item?.amountData?.amount}.{item?.amountData?.amountAgorot}
              {item?.amountData?.isAmountMinus && <div className='price-range'>-</div>}
            </>
          )}
        </div>
          <div
            className={`graph-height ${item.guidId === props.guidId ? 'active-color' : ''}`}
            style={{
              height: `${(item.heighPercent * 100) / 100}%`,
              backgroundColor: item.heighPercent < 0 ? '#82e9a5' : 'var(--theme-light,#e2cff7)'
            }}>
          </div>
        </div>
        <div className={`month mobile ${item.guidId === props.guidId ? 'active-month' : ''}`}>{shortMonth + ' ' + year}</div>
        {/* <div className={`month desktop ${item.guidId === props.guidId ? 'active-month' : ''}`}>{shortMonth + ' ' + year}</div> */}
      </button>
    );
  };

  return (
    <div className='wrapper-info-graph'>
      {props.isEnergy ?
            <>
                  <Swiper
                    ref={swiperRef}
                    className='swiper-graph'
                    modules={[Navigation, Scrollbar]}
                    scrollbar={{
                      draggable: true,
                      hide: false,
                    }}
                    watchOverflow={true}
                    slidesPerView={'auto'}
                    enabled={true}
                    resistanceRatio={0}
                    >
                    {monthView?.map((item, i) => {
                      return (
                        <SwiperSlide key={i}>
                          {shortMonths(item , i)}
                        </SwiperSlide>
                      );
                    })}
                  </Swiper>
            </>
             :
            monthView?.map((item, i) => shortMonths(item , i))
            }
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    indexMonth: state.personalAreaInvoicesPage.indexMonth,
    invoicesInfo: state.personalAreaInvoicesPage.invoicesInfo.history,
    guidId: state.personalAreaInvoicesPage.guidId,
    isEnergy: state.personalAreaInvoicesPage.isEnergy
  };
};

const mapDispatchToProps = {
  setGuidId,
  getInvoiceDataAsync,
  setRemark,
  setCycleDate,
  setSystemSourcePDF
};
export default connect(mapStateToProps, mapDispatchToProps)(Graph);
